import { getIp } from "~/fc/Client";
import { parseUserAgent } from "./Helpers/UAInfoParser";

function isZohoDeskAvailable() {
  return (
    typeof window !== "undefined" &&
    window.ZohoDeskAsap &&
    typeof ZohoDeskAsap !== "undefined"
  );
}

function getFormKey() {
  const departmentId = process.env.ZOHO_DESK_DEPARTMENT_ID;
  const layoutId = process.env.ZOHO_DESK_LAYOUT_ID;
  if (!departmentId || !layoutId) return null;
  return `${departmentId}&&&${layoutId}`;
}

async function prefillZohoDeskForm() {
  const formKey = getFormKey();
  if (!formKey) {
    console.error(
      "Failed to initiate Zoho Desk: Missing department or layout ID."
    );
    return;
  }
  const ip = await getIp();
  const user = $nuxt?.$auth?.User;
  const page = $nuxt?.$route?.path ?? "/";
  const site = window.location.origin || "https://www.freeconvert.com";

  const uaInfo = await parseUserAgent(navigator.userAgent);
  const browser = uaInfo.browser;
  const os = uaInfo.os;

  const prefillData = {
    cf_user_id: { defaultValue: user ? user.id : "", isHidden: true },
    cf_single_line_1: { defaultValue: ip, isHidden: true },
    cf_page: { defaultValue: page, isHidden: true },
    cf_url: { defaultValue: site, isHidden: true },
    cf_browser: { defaultValue: browser, isHidden: true },
    cf_operating_system: { defaultValue: os, isHidden: true },
    email: { defaultValue: user ? user.email : "" },
  };
  ZohoDeskAsap.set("ticket.form.prefillValues", { [formKey]: prefillData });
}

export async function initiateZohoDesk() {
  if (!isZohoDeskAvailable()) return;
  await prefillZohoDeskForm();
}

export function updateZohoDeskPageData(ctx) {
  if (!isZohoDeskAvailable()) return;
  const formKey = getFormKey();
  if (!formKey) return;
  const route = ctx?.$route?.path ?? "/";
  ZohoDeskAsap.set("ticket.form.prefillValues", {
    [formKey]: { cf_page: { defaultValue: route, isHidden: true } },
  });
}

export function updateZohoDeskUserData() {
  if (!isZohoDeskAvailable()) return;
  const formKey = getFormKey();
  if (!formKey) return;
  const user = $nuxt?.$auth?.User;
  ZohoDeskAsap.set("ticket.form.prefillValues", {
    [formKey]: {
      cf_user_id: { defaultValue: user ? user.id : "", isHidden: true },
      email: { defaultValue: user ? user.email : "" },
    },
  });
}

export function resetWidget() {
  if (!isZohoDeskAvailable()) return;
  const formKey = getFormKey();
  if (!formKey) return;

  // Reset prefill values to default
  const prefillData = {
    cf_user_id: { defaultValue: "", isHidden: true },
    cf_single_line_1: { defaultValue: "", isHidden: true },
    cf_page: { defaultValue: "", isHidden: true },
    cf_url: { defaultValue: "", isHidden: true },
    email: { defaultValue: "" },
  };
  ZohoDeskAsap.set("ticket.form.prefillValues", { [formKey]: prefillData });
}

function invokeWidget(action, ...args) {
  if (!isZohoDeskAvailable()) return;

  window.ZohoDeskAsapReady(function () {
    ZohoDeskAsap.invoke(action, ...args);
  });
}

export function openWidget() {
  invokeWidget("open");
}

export function closeWidget() {
  invokeWidget("close");
}

export function showWidget() {
  invokeWidget("show", "app.launcher");
}

export function hideWidget() {
  invokeWidget("hide", "app.launcher");
}
